import React from 'react'

import clean  from 'vegas-js-core/src/objects/clean'

import withDialogs from '../../../../../../contexts/dialogs/withDialogs'
import withi18n    from '../../../../../../contexts/i18n/withi18n'

import { withRouter } from 'react-router-dom'
import { withStyles } from '@material-ui/core/styles'

import blueGrey from '@material-ui/core/colors/blueGrey'

import { FaStethoscope } from 'react-icons/fa'

import ChipsContainer, { styles } from '../../../../../containers/ChipsContainer'

import generify from '../../../../../../things/generify'

import Disease         from '../../../../../../things/medical/Disease'
import Thing           from '../../../../../../things/Thing'
import SuspicionReview from '../../../../../../things/livestock/reviews/SuspicionReview'

const css = () => (
{
    ...styles,
    chip :
    {
        backgroundColor : blueGrey[100],
        margin          : 8
    }
});

class Diseases extends ChipsContainer
{
    editClazz = () => Disease ;

    editInit = ( item ) =>
    {
        if( item )
        {
            const { hypothesis } = item ;
            if( hypothesis )
            {
                const { diseases } = hypothesis ;
                if( diseases instanceof Array )
                {
                    return diseases.map( element =>
                    {
                        if( element instanceof Disease )
                        {
                            return element.clone() ;
                        }
                        return null ;
                    })
                }
            }
        }
        return null ;
    };

    editPrepare = ( datas , props ) =>
    {
        let { item:review } = props ;
        if( review instanceof SuspicionReview )
        {
            review = clean(review.toObject()) ;

            const { hypothesis } = review ;

            if( hypothesis )
            {
                if( datas )
                {
                    if( datas instanceof Array && datas.length === 0 )
                    {
                        datas = null ;
                    }
                    datas = generify(datas,true) ;
                }
                hypothesis.diseases = datas ;
            }
            review = JSON.stringify(review) ;
            return { review } ;
        }
        return null ;
    };

    getEntry = init =>
    {
        const { subjectOf } = this.props ;

        let empty = {} ;

        if( init instanceof Thing )
        {
            empty = init.toObject() ;
        }
        else if( init )
        {
            empty = { ...init } ;
        }

        return new SuspicionReview( { ...empty , subjectOf } ) ;
    };

    getLocale = () => this.props.locale.things.livestock.reviews.suspicion.medical.diseases ;

    getThing = () =>
    {
        const { thing } = this.props ;
        if( thing )
        {
            const { hypothesis } = thing ;
            return hypothesis ;
        }
        return null ;
    };

    onEdit = ( item ) =>
    {
        const { onChange } = this.props ;
        if( onChange )
        {
            onChange( item ) ;
        }
    };
}

Diseases.defaultProps =
{
    ...ChipsContainer.defaultProps ,
    clazz       : Disease,
    chipVariant : 'default' ,
    icon        : <FaStethoscope size={18}/>,
    member      : 'diseases'
};

Diseases.propTypes =
{
    ...ChipsContainer.propTypes
};

export default withStyles( css ) ( withRouter( withi18n( withDialogs( Diseases ) ) ) ) ;
